module.exports = __webpack_public_path__ + "static/media/pic4.80d41b5b.jpg";